/*
 * pz-design-cart.js
 * カートのページのデザインの行（段階 2b）: portal の受け口の値で表示を仕上げ、サイズごとの枚数を変え、まとまりを消す。
 * 設計: printeez-portal/docs/design-simulator/same-print-product-switch.html 4.2・4.6・8.3（段階 2b）
 *
 * - まとまり（版 × カラー）・サイズごとの枚数・金額・製版代/洗浄料・追加料金は Liquid が描く（snippets/pz-design-cart-items.liquid）。
 *   ここでは受け口の最後の応答（assets/pz-cart-fees.js が覚えたもの）が今のカートと合うときだけ、その値を入れる:
 *   題・加工方法・刷る面の画像（画像の無い版は行の商品画像のまま）・面ごとの版ID・単価の内訳（面ごとのプリント代。
 *   合計が行の単価と同じときだけ）・料金の欄の名前（種類ごとのまとまりの「9枚以下 製版代」）・在庫の知らせ・料金の設定の食い違いの知らせ
 * - －・＋・枚数の入力（Enter・欄を離れたときに当てる）: PzCartFees.changeQuantity（増やすときは portal が在庫を確かめる。
 *   だめならその文をまとまりの下に出し、カートの枚数に戻す）→ 描き直し。変えている間に押された・入れられた枚数は行ごとに最後の値を
 *   覚えて（表示もその値）、今の変更が終わってから当てる（速く続けて押しても取りこぼさない）。0 はそのサイズを消す（－ で 0 と同じ）
 * - 削除: PzCartFees.removeLines（まとまりのサイズの行を全部）→ 描き直し
 * - アクリルキーホルダー（受け口の値の unit が「個」。サイズの所は料金の区分）: 個数を変えて区分が変わると、portal が新しい区分の行に
 *   付け替える（その行の key が変わる。assets/pz-cart-fees.js）。押した・打った分は新しい行へ引き継ぎ、エディタのカートへはその版 ×
 *   カラーの合計の個数を書き戻す。まとまりの個数が 1 カラーの最少個数（受け口の値）のときは － を押せなくし、欄に最少個数より
 *   小さい数を打ったら最少個数に直して当てる（0 は今までどおり削除。2026-10-12 オーナー「5 個以下にもできないように」）。
 *   1 カラーの最少個数より少ないまとまりには、その下に知らせを出す（その間は assets/pz-cart-fees.js が
 *   「ご購入手続きへ」を止める。同じ見分け方・同じ文）
 * - 描き直し（Section Rendering）で中身が入れ替わったら、覚えている応答で入れ直す
 * - 待ち表示: 描き直したとき・初めてカートのページを開いたときは、受け口の応答（今のカートと署名が合うもの）を入れ終えるまで、
 *   まとまり・料金の欄を出さず「カートを更新しています」の置き場だけを出す（Liquid が data-pz-dc-state="wait" で描く）。応答を入れ終えたら
 *   外して、内訳つきで一度に出す。8 秒たっても応答が無いときは、今の内容のまま出して「料金の内訳を読み込めませんでした」と添える
 *   （"failed"。その後に応答が届けば普通に入れる）。待っている間は assets/pz-cart-fees.js が「ご購入手続きへ」も止める
 * - エディタのカート（段階 6。assets/pz-editor-cart.js）: 読み込んだときに 1 回、お店のカートをエディタのカートと同じ中身にし、
 *   変えたら描き直す（繰り返さない）。－・＋・削除は上の今の経路でその行だけお店のカートを変え、同じ変更をエディタのカートの受け口
 *   （set_quantity / remove）で書き戻す（受け口の合わせ方は当てない = ほかの違いはそろえない）。受け口が無い（古い portal）・
 *   お客様を特定できないときは今の経路だけ
 */
(function () {
  'use strict';
  if (window.PzDesignCart) return;

  var ROOT = '[data-pz-dc]';
  var ITEM = '[data-pz-dc-item]';
  /* お客様に出す注意（受け口の issues のうち）。ほかは調べる用なので出さない */
  var SHOWN_ISSUES = ['fee_mismatch', 'size_premium_unmapped', 'product_not_found', 'acrylic_retier_failed'];
  var MESSAGES = {
    ignored: 'この商品は料金を計算できません。お手数ですが「デザインを編集」からカートに入れ直してください。',
    busy: 'ほかの変更を反映しています。少し待ってからもう一度お試しください。',
    /* アクリルキーホルダーの個数の欄に、最少個数（n 個）より小さい数を打った（最少個数に直した） */
    minQuantity: function (n) {
      return 'アクリルキーホルダーは1カラー' + n + '個からです';
    },
    /* － が押せないときの読み上げ */
    minusStopped: function (size, n) {
      return size + ' は、1カラー' + n + '個からのため、これ以上減らせません';
    }
  };
  /* まとまりの最少個数（受け口の値。アクリルキーホルダーだけ）を書いておく属性 */
  var MIN_ATTR = 'data-pz-dc-min-qty';
  /* 数える単位の既定（服など。アクリルキーホルダーは受け口の値の unit が「個」） */
  var DEFAULT_UNIT = '枚';
  /* 版の ID（版の商品のメタフィールド printeez.design_version_id。昔の行は _pz_design_version）の形 */
  var VERSION_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  /* カートが空のページで、エディタのカートから商品を入れたときにページを読み込み直した時刻（sessionStorage。続けて読み込み直さない） */
  var RELOAD_KEY = 'pz:editor-cart-reload';
  var SHIRT_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">' +
    '<path d="M8 4 L4 7 L6 9.5 L7.5 8.3 L7.5 20 L16.5 20 L16.5 8.3 L18 9.5 L20 7 L16 4 C16 6 14.2 6.8 12 6.8 C9.8 6.8 8 6 8 4 Z"/></svg>';

  function fees() {
    return window.PzCartFees || null;
  }

  function editorCart() {
    var ec = window.PzEditorCart;
    return ec && typeof ec.call === 'function' ? ec : null;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = String(text);
    return e;
  }

  function yen(n) {
    var v = Math.round(Number(n) || 0);
    return '¥' + v.toLocaleString('ja-JP');
  }

  function keysOf(item) {
    return (item.getAttribute('data-pz-dc-keys') || '').split(',').filter(function (k) { return k !== ''; });
  }

  /* ------------------------------------------------------------------ */
  /* 待ち表示（応答が届くまで行を出さない）                                */
  /* ------------------------------------------------------------------ */

  var STATE_ATTR = 'data-pz-dc-state';
  var SEEN_ATTR = 'data-pz-dc-seen';
  /* 応答を待つ長さ（待ち始めてから。描き直しが続いても数え直さない） */
  var WAIT_MAX_MS = 8000;
  var holdTimer = null;
  var waitSince = 0;
  /* 待っても応答が来なかったカートの署名（同じカートを描き直したときは、また待たずに今の内容を出す） */
  var failedSig = null;

  /*
   * 待ち表示の状態を変える（'wait' / 'failed' / ''）。変わったときだけ書く。「ご購入手続きへ」の止め方は毎回当て直す
   * （Liquid が最初から 'wait' で描いたときも、止めるのはここから）
   */
  function setState(root, st) {
    if ((root.getAttribute(STATE_ATTR) || '') !== st) {
      if (st) root.setAttribute(STATE_ATTR, st);
      else root.removeAttribute(STATE_ATTR);
    }
    var f = fees();
    if (f && typeof f.applyCheckoutState === 'function') f.applyCheckoutState();
  }

  function stopHold() {
    if (holdTimer) window.clearTimeout(holdTimer);
    holdTimer = null;
    waitSince = 0;
  }

  /* 応答を入れ終えた: 待ち表示を外して、まとまり・料金の欄を一度に出す */
  function reveal(root) {
    stopHold();
    failedSig = null;
    setState(root, '');
  }

  /* 8 秒たっても応答が無い: 今の内容（内訳なし）のまま出して、一言添える */
  function giveUp() {
    holdTimer = null;
    waitSince = 0;
    var root = document.querySelector(ROOT);
    if (!root || root.getAttribute(STATE_ATTR) !== 'wait') return;
    var f = fees();
    failedSig = f && typeof f.domSignature === 'function' ? f.domSignature() : null;
    setState(root, 'failed');
  }

  /* 受け口に数えてもらう必要があるカートか（#PzCartFeeState。Liquid が描く。デザインの行か料金の行がある） */
  function needsFees() {
    var el = document.getElementById('PzCartFeeState');
    return !!el && el.getAttribute('data-pz-needs-fees') === 'true';
  }

  /*
   * 新しく描かれたまとまり（初めて開いたとき・描き直したとき）: 待ち表示にして、今のカートに合う応答があればすぐ入れて出す
   * （描き直しの直後に同じ処理の中で入れるので、待ち表示は画面に出ない）。無ければ応答が届くまで待つ
   */
  function holdFresh(root) {
    if (root.hasAttribute(SEEN_ATTR)) return;
    root.setAttribute(SEEN_ATTR, '1');
    if (!needsFees()) {
      stopHold();
      setState(root, '');
      return;
    }
    var f = fees();
    var sig = f && typeof f.domSignature === 'function' ? f.domSignature() : null;
    if (sig !== null && sig === failedSig) {
      /* 前に待っても来なかったのと同じカート: また待たずに今の内容を出す（応答が届いていれば入れて、一言を外す） */
      stopHold();
      setState(root, 'failed');
      apply();
      return;
    }
    setState(root, 'wait');
    if (!waitSince) waitSince = Date.now();
    if (holdTimer) window.clearTimeout(holdTimer);
    holdTimer = window.setTimeout(giveUp, Math.max(0, WAIT_MAX_MS - (Date.now() - waitSince)));
    apply();
  }

  /* 版 × カラーの id（版の UUID は大文字・小文字を区別しない） */
  function normId(id) {
    var s = String(id || '');
    var i = s.indexOf('|');
    return i < 0 ? s.toLowerCase() : s.slice(0, i).toLowerCase() + s.slice(i);
  }

  /* ------------------------------------------------------------------ */
  /* 受け口の値を入れる                                                   */
  /* ------------------------------------------------------------------ */

  function setMessage(item, text, kind) {
    var msg = item.querySelector('[data-pz-dc-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.setAttribute('data-kind', kind || '');
  }

  /*
   * 刷る面の画像を面の名前つきで横に並べる。画像が 1 枚も無い版（段階 2b より前に入れた版）は Liquid の表示（行の商品画像）のまま。
   * 一部の面だけ無いとき・読めないときは、その面は灰色の箱（行の商品画像は前面の仕上がりなので、ほかの面には使わない）
   */
  function fillSides(item, view) {
    var box = item.querySelector('[data-pz-dc-sides]');
    if (!box || !Array.isArray(view.sides) || view.sides.length === 0) return;
    var withImage = view.sides.filter(function (s) { return s && s.imageUrl; });
    if (withImage.length === 0) return;
    var frag = document.createDocumentFragment();
    view.sides.forEach(function (s) {
      var side = el('div', 'pz-dc-side');
      var img = el('div', 'pz-dc-img');
      var url = s.imageUrl || '';
      if (url) {
        var im = document.createElement('img');
        im.alt = s.label || '';
        im.loading = 'lazy';
        im.width = 70;
        im.height = 70;
        im.src = url;
        /* 読めなければ灰色の箱にする（版の画像が消えた等） */
        im.addEventListener('error', function () {
          img.innerHTML = SHIRT_SVG;
        });
        img.appendChild(im);
      } else {
        img.innerHTML = SHIRT_SVG;
      }
      side.appendChild(img);
      side.appendChild(el('div', 'pz-dc-cap', s.label || ''));
      frag.appendChild(side);
    });
    box.innerHTML = '';
    box.appendChild(frag);
  }

  /* 面ごとの版ID（見出しの下に「版ID:7K3Q /001 Black」）。版が無ければ出さない */
  function fillPlates(item, view) {
    var box = item.querySelector('[data-pz-dc-plates]');
    if (!box || !Array.isArray(view.plateSections)) return;
    box.innerHTML = '';
    view.plateSections.forEach(function (sec) {
      if (!sec || !Array.isArray(sec.plates) || sec.plates.length === 0) return;
      box.appendChild(el('div', 's', sec.heading || ''));
      sec.plates.forEach(function (p) {
        box.appendChild(el('div', '', p.text || ('版ID:' + p.plateId)));
      });
    });
    box.hidden = box.childNodes.length === 0;
  }

  /*
   * 単価の内訳（本体と面ごとのプリント代）。受け口の内訳の合計が、カートの行の単価（Liquid が書いた data-pz-dc-unit-price。
   * 金額は 100 倍の値）と同じときだけ入れる（料金の設定が変わった後の行は、Liquid の 2 行の内訳のまま）
   */
  function fillUnit(item, view) {
    var box = item.querySelector('[data-pz-dc-unit]');
    var b = view.unitBreakdown;
    if (!box || !b || !b.body || !Array.isArray(b.prints)) return;
    var unitPrice = Number(box.getAttribute('data-pz-dc-unit-price')) / 100;
    if (!(unitPrice > 0) || Math.round(b.total) !== Math.round(unitPrice)) return;
    box.innerHTML = '';
    box.appendChild(el('div', 't', '単価の内訳（1 ' + (view.unit || DEFAULT_UNIT) + 'あたり）'));
    var rows = [{ label: b.body.label, amount: b.body.amount }].concat(
      b.prints.map(function (p) { return { label: p.label, amount: p.amount }; })
    );
    rows.forEach(function (r) {
      var row = el('div', 'r');
      row.appendChild(el('span', '', r.label));
      row.appendChild(el('span', '', yen(r.amount)));
      box.appendChild(row);
    });
    box.hidden = false;
  }

  function fillItem(item, view, response) {
    var title = item.querySelector('[data-pz-dc-title]');
    if (title && view.title && title.textContent !== view.title) title.textContent = view.title;
    var method = item.querySelector('[data-pz-dc-method]');
    if (method && view.methodLabel && method.textContent !== view.methodLabel) method.textContent = view.methodLabel;
    fillSides(item, view);
    fillPlates(item, view);
    fillUnit(item, view);
    /* 在庫の知らせ（カート全体で数えて、在庫より多い商品・カラー・サイズ） */
    var keys = keysOf(item);
    var stock = (response.stock || []).filter(function (s) {
      return (s.keys || []).some(function (k) { return keys.indexOf(String(k)) >= 0; });
    });
    var current = item.querySelector('[data-pz-dc-msg]');
    var kind = current ? current.getAttribute('data-kind') : '';
    if (stock.length > 0) setMessage(item, stock.map(function (s) { return s.message; }).join(' '), 'stock');
    else if (kind === 'stock' || kind === 'ignored') setMessage(item, '', '');
    fillMinNote(item, view);
    /* 1 カラーの最少個数（アクリルキーホルダーだけ。－ を止める・打った数を直すのに使う。分からなければ書かない = 今までどおり） */
    var min = view.unit === '個' && view.acrylic ? Number(view.acrylic.minQty) || 0 : 0;
    if (min > 0) item.setAttribute(MIN_ATTR, String(min));
    else item.removeAttribute(MIN_ATTR);
    paintLimit(item);
  }

  /*
   * アクリルキーホルダーの最少個数の知らせ（まとまりの下の専用の欄。枚数の変更の知らせとは別）: その版 × カラーの個数が、1 カラーの
   * 最少個数（受け口の値。料金表を読めなければ無い）より少ないときに出す。見分け方と文は assets/pz-cart-fees.js のもの
   * （その間は「ご購入手続きへ」も止まる。同じ文がボタンの横にも出る）
   */
  function fillMinNote(item, view) {
    var note = item.querySelector('[data-pz-dc-min]');
    var f = fees();
    if (!note || !f || typeof f.shortOfMinimum !== 'function' || typeof f.minQuantityMessage !== 'function') return;
    var min = f.shortOfMinimum(view);
    var text = min > 0 ? f.minQuantityMessage(min) : '';
    if (note.textContent !== text) note.textContent = text;
    note.hidden = !text;
  }

  /*
   * 料金の欄の名前（受け口の内訳の「9枚以下 製版代」。9 は料金の設定で変わる）: 種類ごとのまとまり（製版代・洗浄料）の見出しを
   * 入れ替える。回数（「× 3」）は Liquid が書いたカートの値（data-pz-dc-fee-count）のまま
   */
  function fillFees(root, response) {
    var sections = (response.setupFees && response.setupFees.sections) || [];
    var labels = {};
    sections.forEach(function (sec) {
      (sec.plates || []).forEach(function (p) {
        (p.items || []).forEach(function (it) {
          if (it && it.kind && it.label && !labels[it.kind]) labels[it.kind] = String(it.label);
        });
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-pz-dc-fee-group]'), function (group) {
      var label = labels[group.getAttribute('data-pz-dc-fee-group')];
      var span = group.querySelector('[data-pz-dc-fee-label]');
      if (!label || !span) return;
      var count = Number(group.getAttribute('data-pz-dc-fee-count')) || 0;
      var text = label + (count > 1 ? ' × ' + count : '');
      if (span.textContent !== text) span.textContent = text;
    });
    var note = root.querySelector('[data-pz-dc-issues]');
    if (note) {
      var issues = (response.issues || []).filter(function (i) { return SHOWN_ISSUES.indexOf(i.type) >= 0; });
      /* お客様向けの文（customerMessage）があればそれを出す。同じ文は 1 回だけ */
      var texts = [];
      issues.forEach(function (i) {
        var t = i.customerMessage || i.message;
        if (t && texts.indexOf(t) < 0) texts.push(t);
      });
      var text = texts.join(' ');
      if (note.textContent !== text) note.textContent = text;
      note.hidden = !text;
    }
  }

  /* 今のカートに合う受け口の応答で、表示を仕上げる（合わなければ何もしない = Liquid の表示のまま） */
  function apply() {
    var root = document.querySelector(ROOT);
    var f = fees();
    if (!root || !f || typeof f.responseFor !== 'function') return;
    var sig = f.domSignature();
    var response = sig === null ? null : f.responseFor(sig);
    if (!response || !Array.isArray(response.items)) return;
    if (root.getAttribute('data-pz-dc-applied') === sig) {
      if (root.hasAttribute(STATE_ATTR)) reveal(root);
      return;
    }
    try {
      var byId = {};
      response.items.forEach(function (v) { byId[normId(v.id)] = v; });
      var ignored = {};
      (response.ignored || []).forEach(function (i) {
        if (i.reason === 'unknown_version' || i.reason === 'variant_mismatch') ignored[String(i.key)] = true;
      });
      Array.prototype.forEach.call(root.querySelectorAll(ITEM), function (item) {
        var view = byId[normId(item.getAttribute('data-pz-dc-item'))];
        if (view) {
          fillItem(item, view, response);
          return;
        }
        /* 受け口が数えなかった行（版とバリアントが合わない等）だけのまとまり */
        var keys = keysOf(item);
        if (keys.length > 0 && keys.every(function (k) { return ignored[k]; })) setMessage(item, MESSAGES.ignored, 'ignored');
      });
      fillFees(root, response);
      root.setAttribute('data-pz-dc-applied', sig);
    } finally {
      /* 入れ終えたら（途中で失敗しても）出す。出さないままにしない */
      reveal(root);
    }
  }

  /* ------------------------------------------------------------------ */
  /* －・＋・削除                                                         */
  /* ------------------------------------------------------------------ */

  /* カートが空になったら、空のカートの表示にする（Dawn の updateQuantity と同じ: cart-items と見積もりの欄に is-empty） */
  function toggleEmpty() {
    var f = fees();
    var count = f && typeof f.itemCount === 'function' ? f.itemCount() : null;
    if (count === null) return;
    var empty = count === 0;
    var nodes = [document.querySelector('cart-items'), document.getElementById('main-cart-items'), document.getElementById('main-cart-footer')];
    nodes.forEach(function (n) {
      if (n) n.classList.toggle('is-empty', empty);
    });
  }

  /* 枚数を変えた・行を消した後の描き直し（pz-cart-options の描き直し。無いページはページを読み込み直す） */
  function refreshSections() {
    if (typeof window.PzCartRefreshSections !== 'function') {
      window.location.reload();
      return null;
    }
    return Promise.resolve(window.PzCartRefreshSections()).then(toggleEmpty);
  }

  function setBusy(item, on) {
    item.classList.toggle('is-busy', !!on);
    item.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /*
   * エディタのカートの商品（段階 6）: まとまりの id（「版の id|カラー」= 版の商品のメタフィールド・バリアントのカラー。昔の行は
   * _pz_design_version・_pz_color）と、行のサイズ（バリアントのサイズ。昔の行は _pz_size）。
   * 形が違えば null（書き戻さない）
   */
  function targetOf(item, row) {
    var id = item.getAttribute('data-pz-dc-item') || '';
    var i = id.indexOf('|');
    if (i <= 0 || i === id.length - 1 || !VERSION_ID_RE.test(id.slice(0, i))) return null;
    var target = { versionId: id.slice(0, i).toLowerCase(), color: id.slice(i + 1) };
    if (row) {
      var size = row.getAttribute('data-pz-dc-size') || '';
      if (!size) return null;
      target.size = size;
    }
    return target;
  }

  /*
   * お店のカートで変えたデザインの行と同じ変更を、エディタのカートにも書き戻す（段階 6 の 0.1）。受け口の合わせ方は当てない
   * （ほかの違いはそろえない）。受け口が無い・お客様を特定できないと分かっていれば何もしない。書き戻せなくてもお店のカートはそのまま
   * （次にカートのページを開いたときにエディタのカートの中身にそろう）
   */
  function writeBack(op, target) {
    var ec = editorCart();
    if (!ec || !target || !ec.active()) return;
    ec.call(op, { target: target }).then(function (r) {
      if (!r.ok && r.available && window.console && console.warn) console.warn('[pz-design-cart] エディタのカートに書き戻せません', op, r.code);
    });
  }

  /*
   * エディタのカートに書き戻す枚数（アクリルキーホルダーだけ直す。エディタのカートは版 × カラーの個数で数える）: 区分の付け替え
   * （応答の retier）でその版 × カラーが 1 行にまとまったときは、その合計の個数。付け替えが無くても、応答の表示の値（items）に
   * その版 × カラー（unit が「個」）があれば、その個数。同じ版 × カラーの行がほかにもあったとき、変えた行の個数だけを書き戻さない
   */
  function groupQuantityTarget(target, response) {
    if (!target || !response) return target;
    var retier = Array.isArray(response.retier) ? response.retier : [];
    for (var i = 0; i < retier.length; i++) {
      var r = retier[i];
      if (r && String(r.versionId).toLowerCase() === target.versionId && r.color === target.color) {
        target.quantity = Number(r.quantity) || 0;
        return target;
      }
    }
    var views = Array.isArray(response.items) ? response.items : [];
    for (var j = 0; j < views.length; j++) {
      var v = views[j];
      if (v && v.unit === '個' && normId(v.id) === target.versionId + '|' + target.color) {
        target.quantity = Number(v.quantity) || 0;
        return target;
      }
    }
    return target;
  }

  /*
   * 「デザインを編集」のリンクに秘密鍵（#key=）を足す（2026-10-29）。新しい行には鍵が無い（注文のデータに鍵を残さない）ので、
   * エディタのカートの応答（editKeys）から、カートに入れたときに編集権があったデザインだけ足す。昔の行は Liquid が鍵つきで描く。
   * フラグメントに置き、サーバー・解析に渡さない
   */
  function fillEditLinks() {
    var ec = editorCart();
    if (!ec || typeof ec.editKeyFor !== 'function') return;
    var links = document.querySelectorAll('a.pz-dc-edit[data-pz-dc-pid]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      if (!href || href.indexOf('#key=') >= 0) continue;
      var key = ec.editKeyFor(a.getAttribute('data-pz-dc-pid'));
      if (key) a.setAttribute('href', href + '#key=' + encodeURIComponent(key));
    }
  }

  /* 開いたときの同期（お店のカートを書き換える）の途中なら、終わってから変える（お店のカートを同時に書き換えない） */
  function afterEditorCartSync() {
    var ec = editorCart();
    return ec && typeof ec.settled === 'function' ? ec.settled() : Promise.resolve();
  }

  /*
   * 枚数の変更（－・＋・枚数の入力）は 1 つずつ順に当てる。変えている間（本番で 1 回 2 秒ほど）に押された・入れられた枚数は、
   * サイズの行（カートの行の key）ごとに最後の値だけ want に覚え（表示もその値）、今の変更が終わってから当てる
   */
  var want = {};
  /* 今当てている変更（{ key, quantity, itemId, from }。無ければ null。from は行が置き換わったときの前の key） */
  var running = null;
  /* 枚数の入力欄で打っている途中の欄（{ key, el }。描き直しで欄が入れ替わったら、打った値を新しい欄に戻す） */
  var typing = null;

  /*
   * アクリルキーホルダーの区分の付け替えで置き換わった行（前の行の key → 新しい行の key）。描き直すまでの間、前の行の欄で押した・
   * 打った分を新しい行のものとして覚える（描き直した後は、前の key の行は画面に無い）
   */
  var moved = {};
  /* 当て終えた後のまとまりに出す知らせ（まとまりの id → 文。最少個数に直したとき） */
  var notes = {};

  function hasWant(key) {
    return Object.prototype.hasOwnProperty.call(want, key);
  }

  /* サイズの行のカートの行の key（置き換わった行は新しい行の key） */
  function keyOfRow(row) {
    var key = row.getAttribute('data-pz-dc-row') || '';
    return Object.prototype.hasOwnProperty.call(moved, key) ? moved[key] : key;
  }

  /*
   * 行が新しい区分の行に置き換わった（PzCartFees.changeQuantity の onMoved。描き直しの前に呼ばれる）: まだ当てていない枚数・
   * 打っている途中の欄・今当てている変更を、新しい行の key に付け替える（付け替えないと、行が無くなったものとして捨ててしまう）
   */
  function moveKey(from, to) {
    if (!from || !to || from === to) return;
    if (hasWant(from)) {
      want[to] = want[from];
      delete want[from];
    }
    moved[from] = to;
    if (typing && typing.key === from) typing.key = to;
    if (running && running.key === from) {
      running.key = to;
      running.from = from;
    }
  }

  /* サイズの行・まとまり（描き直すと要素が変わるので、そのつど key・id で探す） */
  function rowByKey(key) {
    var rows = document.querySelectorAll(ROOT + ' [data-pz-dc-row]');
    for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-pz-dc-row') === key) return rows[i];
    return null;
  }
  function itemById(id) {
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) if (items[i].getAttribute('data-pz-dc-item') === id) return items[i];
    return null;
  }

  /* 行のカートの枚数（Liquid が書いた値）と、表示する枚数（まだ当てていない値があればそれ） */
  function cartQty(row) {
    return Number(row.getAttribute('data-pz-dc-qty')) || 0;
  }
  function shownQty(row) {
    var key = keyOfRow(row);
    return hasWant(key) ? want[key] : cartQty(row);
  }

  /* 枚数の入力欄に表示する枚数を入れる（打っている途中の欄はそのまま） */
  function paint(row) {
    var input = row.querySelector('[data-pz-dc-qn]');
    if (!input || (typing && typing.el === input)) return;
    var text = String(shownQty(row));
    if (input.value !== text) input.value = text;
  }
  function paintAll() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT + ' [data-pz-dc-row]'), paint);
    Array.prototype.forEach.call(document.querySelectorAll(ITEM), paintLimit);
  }

  /* まとまり（版 × カラー）の最少個数（アクリルキーホルダーで、受け口の値が届いているときだけ。無ければ 0）と、表示している個数の合計 */
  function minOf(item) {
    return item ? Number(item.getAttribute(MIN_ATTR)) || 0 : 0;
  }
  function groupQty(item) {
    var n = 0;
    Array.prototype.forEach.call(item.querySelectorAll('[data-pz-dc-row]'), function (row) { n += shownQty(row); });
    return n;
  }

  /*
   * － の押せる・押せない: まとまりの個数が最少個数以下なら押せない（0 にするのは「削除」だけ）。最少個数の無いまとまり（服など）は
   * 何も変えない
   */
  function paintLimit(item) {
    var min = minOf(item);
    if (!(min > 0)) return;
    var stop = groupQty(item) <= min;
    Array.prototype.forEach.call(item.querySelectorAll('[data-pz-dc-row]'), function (row) {
      var button = row.querySelector('[data-pz-dc-step="-1"]');
      if (!button) return;
      if (!button.hasAttribute('data-pz-dc-label')) button.setAttribute('data-pz-dc-label', button.getAttribute('aria-label') || '');
      var label = stop ? MESSAGES.minusStopped(row.getAttribute('data-pz-dc-size') || '', min) : button.getAttribute('data-pz-dc-label');
      if (button.disabled !== stop) button.disabled = stop;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
  }

  /* 覚えている枚数を 1 つずつ当てる（当てている間は何もしない。終わったら次へ） */
  function drain() {
    var f = fees();
    if (running || !f || typeof f.changeQuantity !== 'function') return;
    var keys = Object.keys(want);
    var key = null;
    var row = null;
    for (var i = 0; i < keys.length && !row; i++) {
      row = rowByKey(keys[i]);
      /* 行が無くなった（0 にした・ほかで消した）ものは捨てる */
      if (row) key = keys[i];
      else delete want[keys[i]];
    }
    if (!row) return;
    var quantity = want[key];
    var item = row.closest(ITEM);
    var target = item ? targetOf(item, row) : null;
    if (target) target.quantity = quantity;
    var run = { key: key, quantity: quantity, itemId: item ? item.getAttribute('data-pz-dc-item') : '', from: null };
    running = run;
    if (item) {
      setMessage(item, '', '');
      setBusy(item, true);
    }
    afterEditorCartSync()
      .then(function () {
        return f.changeQuantity(key, quantity, { onChanged: refreshSections, onMoved: moveKey });
      })
      .then(null, function () {
        return null;
      })
      .then(function (r) {
        var ok = !!(r && r.ok);
        if (ok && r.changed) writeBack('set_quantity', groupQuantityTarget(target, r.response));
        /*
         * だめだったとき（在庫など）はカートの枚数に戻す。当てている間に別の枚数を頼まれていれば、続けてそれを当てる
         * （行が置き換わっていれば run.key は新しい行の key）
         */
        if (!ok || want[run.key] === quantity) delete want[run.key];
        if (run.from) delete moved[run.from];
        running = null;
        /* 描き直したときは新しい要素になっている（描き直していなければ、この要素のまま） */
        var el = run.itemId ? itemById(run.itemId) : null;
        if (el) {
          setBusy(el, false);
          if (!ok) setMessage(el, (r && r.message) || MESSAGES.busy, 'change');
          else if (notes[run.itemId]) setMessage(el, notes[run.itemId], 'min');
        }
        delete notes[run.itemId];
        paintAll();
        drain();
      });
  }

  /* 行の枚数を n にする（覚えて、順に当てる） */
  function requestQty(row, n) {
    var key = keyOfRow(row);
    if (!key) return;
    if (n === cartQty(row) && !(running && running.key === key)) delete want[key];
    else want[key] = n;
    var item = row.closest(ITEM);
    if (item) setMessage(item, '', '');
    paint(row);
    if (item) paintLimit(item);
    drain();
  }

  function onStep(button) {
    var row = button.closest('[data-pz-dc-row]');
    if (!row || !fees()) return;
    /* 打っている途中の枚数があれば先に当てる（その値から 1 つ増やす・減らす） */
    if (typing && typing.el.isConnected) commitInput(typing.el);
    var current = shownQty(row);
    var delta = Number(button.getAttribute('data-pz-dc-step')) || 0;
    /* アクリルキーホルダー: まとまりの個数が最少個数なら減らさない（ボタンも押せなくしてある。paintLimit） */
    var item = row.closest(ITEM);
    if (delta < 0 && item && minOf(item) > 0 && groupQty(item) <= minOf(item)) return;
    var next = Math.max(0, current + delta);
    if (next !== current) requestQty(row, next);
  }

  /* 枚数の入力欄の値（全角の数字も読む）。0 以上の整数でなければ null */
  function parseQty(text) {
    var s = String(text || '')
      .replace(/[０-９]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
      })
      .trim();
    return /^\d{1,5}$/.test(s) ? Number(s) : null;
  }

  /* 入力欄の枚数を当てる（Enter・欄を離れたとき）。数でない・マイナスは前の値に戻す。0 はそのサイズを消す（－ で 0 にしたときと同じ） */
  function commitInput(input) {
    if (typing && typing.el === input) typing = null;
    var row = input.isConnected ? input.closest('[data-pz-dc-row]') : null;
    if (!row) return;
    var n = parseQty(input.value);
    /*
     * アクリルキーホルダー: まとまりの個数が最少個数より少なくなる数（1〜）は、まとまりが最少個数になる数に直して当て、知らせを出す
     * （0 は今までどおり、その行を消す）。最少個数が分からない間は今までどおり（受け口が断る）
     */
    var item = row.closest(ITEM);
    var min = minOf(item);
    var note = '';
    if (n !== null && n > 0 && min > 0) {
      var others = groupQty(item) - shownQty(row);
      if (others + n < min) {
        n = min - others;
        note = MESSAGES.minQuantity(min);
      }
    }
    if (n === null || n === shownQty(row)) {
      paint(row);
      if (note) setMessage(item, note, 'min');
      return;
    }
    requestQty(row, n);
    /* 当て終えて描き直した後のまとまりに出す（drain）。当てている間は知らせを消してあるので、ここでも出しておく */
    if (note) {
      notes[item.getAttribute('data-pz-dc-item') || ''] = note;
      setMessage(item, note, 'min');
    }
  }

  function qnOf(target) {
    return target && target.matches && target.matches('[data-pz-dc-qn]') && target.closest(ROOT) ? target : null;
  }

  /*
   * 描き直した後: 覚えている枚数を新しい入力欄に出し、打っている途中だった欄は新しい欄に打った値を戻して続けられるようにする
   * （戻せない = フォーカスを移せない iOS などは、打った値を当てる）
   */
  function afterRender() {
    fillEditLinks();
    var t = typing;
    if (t && !t.el.isConnected) {
      typing = null;
      var row = rowByKey(t.key);
      var input = row ? row.querySelector('[data-pz-dc-qn]') : null;
      if (input) {
        input.value = t.el.value;
        typing = { key: t.key, el: input };
        try {
          input.focus({ preventScroll: true });
          input.setSelectionRange(input.value.length, input.value.length);
        } catch (e) {
          /* 選べない欄 */
        }
        if (document.activeElement !== input) commitInput(input);
      }
    }
    paintAll();
  }

  function onRemove(button) {
    var item = button.closest(ITEM);
    var f = fees();
    if (!item || !f || typeof f.removeLines !== 'function') return;
    if (item.classList.contains('is-busy')) return;
    /* まだ当てていない枚数は捨てる（まとまりごと消す） */
    keysOf(item).forEach(function (k) {
      delete want[k];
    });
    var target = targetOf(item, null);
    setMessage(item, '', '');
    setBusy(item, true);
    afterEditorCartSync()
      .then(function () {
        return f.removeLines(keysOf(item), { onChanged: refreshSections });
      })
      .then(function (r) {
        if (r && r.ok && r.changed) writeBack('remove', target);
        if (!document.body.contains(item)) return;
        setBusy(item, false);
        if (!r || !r.ok) setMessage(item, (r && r.message) || MESSAGES.busy, 'change');
      });
  }

  /*
   * 読み込んだときの同期でお店のカートを変えた後の描き直し。カートが空のページ（購入手続きのボタンが止まったまま描かれている）に
   * 商品を入れたときはページを読み込み直す（続けては読み込み直さない）
   */
  function refreshAfterSync() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.classList.contains('is-empty')) {
      var last = 0;
      try {
        last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0;
        if (Date.now() - last > 60 * 1000) {
          window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          return null;
        }
      } catch (e) {
        /* 残せない環境では読み込み直さない（続けて読み込み直さないため） */
      }
    }
    return refreshSections();
  }

  /* エディタのカート（段階 6）: 読み込んだときに 1 回だけ、お店のカートをエディタのカートと同じ中身にする（描き直しでは繰り返さない） */
  function syncEditorCart() {
    var ec = editorCart();
    if (!ec || typeof ec.sync !== 'function') return;
    var done = ec.sync({ onChanged: refreshAfterSync, onlyIfUsed: true });
    if (done && typeof done.then === 'function') done.then(fillEditLinks, function () {});
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t || !t.closest(ROOT)) return;
    var step = t.closest('[data-pz-dc-step]');
    if (step) {
      ev.preventDefault();
      onStep(step);
      return;
    }
    var remove = t.closest('[data-pz-dc-remove]');
    if (remove) {
      ev.preventDefault();
      onRemove(remove);
    }
  });

  /* 枚数の入力欄: 打ち始め・Enter（カートのフォームは送らない）・Esc（前の値に戻す）・欄を離れたとき */
  document.addEventListener('focusin', function (ev) {
    var input = qnOf(ev.target);
    var row = input ? input.closest('[data-pz-dc-row]') : null;
    if (row) typing = { key: keyOfRow(row), el: input };
  });
  document.addEventListener('keydown', function (ev) {
    var input = qnOf(ev.target);
    if (!input || ev.isComposing || ev.keyCode === 229) return;
    if (ev.key === 'Enter') {
      ev.preventDefault();
      commitInput(input);
      input.blur();
    } else if (ev.key === 'Escape' || ev.key === 'Esc') {
      typing = null;
      var row = input.closest('[data-pz-dc-row]');
      if (row) paint(row);
      input.blur();
    }
  });
  document.addEventListener('focusout', function (ev) {
    var input = qnOf(ev.target);
    if (!input) return;
    /* 描き直しで欄が外れたとき（外れた欄の focusout）は当てない（afterRender が新しい欄に戻す） */
    window.setTimeout(function () {
      if (input.isConnected && document.activeElement !== input) commitInput(input);
    }, 0);
  });

  /* 受け口の新しい応答（pz-cart-fees.js）・描き直し（中身の入れ替え）のたびに入れ直す */
  document.addEventListener('pz:cart-fees', function () {
    var root = document.querySelector(ROOT);
    if (root) root.removeAttribute('data-pz-dc-applied');
    apply();
  });
  var timer = null;
  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      apply();
    }, 30);
  }
  function start() {
    var first = document.querySelector(ROOT);
    if (first) holdFresh(first);
    apply();
    var target = document.getElementById('main-cart-items') || document.body;
    new MutationObserver(function () {
      var root = document.querySelector(ROOT);
      if (root) holdFresh(root);
      else if (holdTimer || waitSince) {
        /* まとまりが無くなった（デザインの行を全部消した）: 待ちをやめて、「ご購入手続きへ」の止めを外す */
        stopHold();
        var f = fees();
        if (f && typeof f.applyCheckoutState === 'function') f.applyCheckoutState();
      }
      if (root && !root.hasAttribute('data-pz-dc-applied')) schedule();
      afterRender();
    }).observe(target, { childList: true, subtree: true });
    syncEditorCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.PzDesignCart = { apply: apply };
})();
